import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const TableSkeleton: React.FC = () => {
  // Define column widths
  const columnWidths = 'grid-cols-11';

  return (
    <div className="m-2 mt-6">
      {/* Search and filter bar */}
      <div className="flex justify-end mb-5 gap-2">
        <div className="w-72">
          <Skeleton height={36} borderRadius={4} />
        </div>
        <div className="w-10">
          <Skeleton height={36} borderRadius={4} />
        </div>
      </div>

      {/* Table header */}
      <div className={`grid ${columnWidths} border-b border-gray-100 py-2`}>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((item) => (
          <div key={item}>
            <Skeleton height={20} />
          </div>
        ))}
      </div>

      {/* Table rows */}
      {[1, 2, 3, 4, 5].map((row) => (
        <div
          key={row}
          className={`grid ${columnWidths} border-b border-gray-100 py-4`}
        >
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((cell) => (
            <div key={cell}>
              <Skeleton height={16} />
            </div>
          ))}
        </div>
      ))}

      {/* Pagination */}
      <div className="flex justify-end gap-2 mt-5 items-center">
        <div className="w-28">
          <Skeleton height={24} />
        </div>
        <div className="w-20">
          <Skeleton height={32} />
        </div>
        <div className="w-24">
          <Skeleton height={24} />
        </div>
        <div className="w-16">
          <Skeleton height={32} />
        </div>
      </div>
    </div>
  );
};

export default TableSkeleton;
